import { create } from 'zustand';

export enum MaterialStateEnum {
  Xray = 'xray',
  Texture = 'texture',
}

interface MeshMaterialStore {
  materialState: MaterialStateEnum;
  setMaterialState: (materialState: MaterialStateEnum) => void;
}

export const useMeshMaterialStore = create<MeshMaterialStore>((set) => ({
  materialState: MaterialStateEnum.Texture,
  setMaterialState: (materialState: MaterialStateEnum) =>
    set({ materialState }),
}));
